import { Injectable } from '@angular/core';
import { sourceIdColors } from '../../../cross-team-shared/constants';
import {
  convertHexToRGB,
  denormalizeRGB,
} from '../../../cross-team-shared/misc-utils/color-utils';
import { LayerSettingsState3D } from '../../../cross-team-shared/state/layer-settings-state-3d';
import { AbstractLayerSettingsService } from '../../../cross-team-shared/toolbars/layer-settings/abstract-layer-settings.service';
import { ObjectWith, RGBA } from '../../../cross-team-shared/types/misc';
import { PointCloudContentStore } from '../../state/point-cloud-content-store';

@Injectable()
export class LayerSettingsService3D extends AbstractLayerSettingsService<
  PointCloudContentStore,
  LayerSettingsState3D
> {
  protected getDefaultSettings() {
    return new LayerSettingsState3D(this.buildPointAppearanceBySensor());
  }

  private buildPointAppearanceBySensor() {
    const sensors = this.store.state().output.meta.multi_point_cloud?.sensors;
    const pointAppearanceBySensor: ObjectWith<RGBA> = {};
    if (sensors) {
      sensors.forEach((sensor, i) => {
        const color = sourceIdColors[i % sourceIdColors.length];
        const [r, g, b] = convertHexToRGB(color).map((index) =>
          denormalizeRGB(index),
        );

        pointAppearanceBySensor[sensor.source_id] = [r, g, b, 1];
      });
    }

    return pointAppearanceBySensor;
  }
}
